import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'app-delivery-date-renderer',
  standalone: false,
  templateUrl: './delivery-date-renderer.component.html',
  styleUrls: [],
})
export class DeliveryDateRendererComponent {
  deliveryDate!: number;

  agInit(params: ICellRendererParams): void {
    this.deliveryDate = parseInt(params.value, 10);
  }
}
